import { borderRadius, Button } from '@toggle/design-system';
import styled from 'styled-components';

export const UpgradeButton = styled(Button)`
  ${borderRadius.r4}
`;
